import { createBrowserHistory } from "history";

import { getAppBasename } from "helpers/url";

export const history = createBrowserHistory({
  basename: getAppBasename(),
});
